import { GeocoderException } from './geocoder.exception';

export class InvalidArgumentException extends GeocoderException {}
